import FetchService from "./FetchService";
// Private static variables
const baseUrl = "/aviso/admissions/";
// Service class
export default class AdmissionService {
    /**
     * Fetches a preview of the given text with template variables injected from the server.
     * Adds spans to the template which visually distinguish template variables
     *
     * @param {string} previewText - text to preview
     * @param {boolean} escapeHtml - whether this string requires escaping html
     */
    static getApplicationReceiptConfirmationEmailPreview(previewText, escapeHtml) {
        return FetchService.getSingleResponse(baseUrl + "getApplicationReceiptConfirmationPreview", { previewText, escapeHtml });
    }
    static getApplicationReceiptConfirmationConfiguration() {
        // eslint-disable-line max-len
        return FetchService.get(baseUrl + "getApplicationReceiptConfirmationConfig");
    }
    static updateApplicationreceiptConfirmationConfiguration(config) {
        return FetchService.postSingleResponse(baseUrl + "updateApplicationReceiptConfirmationConfig", config);
    }
}
